/* eslint-disable */
import * as Types from './types';

import { ImageFragmentDoc } from './Image';
export type ModuleBlogHeroImageFragment = { __typename?: 'ModuleBlogHeroImage', mobile?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, desktop?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null };

export type ModuleBlogHeroFragment = { __typename: 'ModuleBlogHero', proContent?: boolean | null, slidesCollection?: { __typename?: 'ModuleBlogHeroSlidesCollection', items: Array<{ __typename?: 'ModuleBlogHeroSlide', title?: string | null, subtitle?: string | null, description?: string | null, buttonLabel?: string | null, buttonLink?: string | null, openLinkInNewTab?: boolean | null, featuredImage?: { __typename?: 'ModuleBlogHeroImage', mobile?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, desktop?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null, imagesCollection?: { __typename?: 'ModuleBlogHeroSlideImagesCollection', items: Array<{ __typename?: 'ModuleBlogHeroImage', mobile?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, desktop?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null } | null> } | null };

export declare const ModuleBlogHeroImageFragment: import("graphql").DocumentNode;
export declare const ModuleBlogHeroFragment: import("graphql").DocumentNode;
export const ModuleBlogHeroImageFragmentDoc = /*#__PURE__*/ `
    fragment ModuleBlogHeroImageFragment on ModuleBlogHeroImage {
  mobile {
    ...ImageFragment
  }
  desktop {
    ...ImageFragment
  }
}
    `;
export const ModuleBlogHeroFragmentDoc = /*#__PURE__*/ `
    fragment ModuleBlogHeroFragment on ModuleBlogHero {
  __typename
  slidesCollection(limit: 4) {
    items {
      title
      subtitle
      description
      buttonLabel
      buttonLink
      openLinkInNewTab
      featuredImage {
        ...ModuleBlogHeroImageFragment
      }
      imagesCollection(limit: 2) {
        items {
          ...ModuleBlogHeroImageFragment
        }
      }
    }
  }
  proContent
}
    `;